import { html } from 'lit';
import { classMap } from 'lit/directives/class-map.js';
import componentStyles from './3-up-grid.css.lit.ts';
import { OutlineElement } from '../../base/outline-element/outline-element.ts';

/**
 * Three cards in a row
 *
 * @element hf-3-up-grid
 */
export default class ThreeUpGrid extends OutlineElement {
  static styles = [super.styles, componentStyles];
  static get properties() {
    return {
      styleClass: { type: String },
    };
  }

  constructor() {
    super();
    this.title = '';
    this.styleClass = '';
  }

  render() {
    return html`
      <div
        class="${classMap({
          'three-up-grid': true,
          [`three-up-grid--${this.styleClass}`]: !!this.styleClass,
        })}"
      >
        <div class="three-up-grid__list">
          <slot></slot>
        </div>
      </div>
    `;
  }
}
customElements.define('hf-3-up-grid', ThreeUpGrid);
